export const ROUTE_TYPE = {
  COMMON: 'common',
  DATASETS: 'datasets',
  ENTRIES: 'entries',
  INSTRUMENTS: 'instruments',
  SAMPLES: 'samples',
  USERS: 'users'
};

export default {
  ROOT: {
    path: '/'
  },
  // 共通
  COMMON_ERROR: {
    id: 'SCR-DCV-5040',
    name: 'エラー表示',
    path: '/error',
    type: ROUTE_TYPE.COMMON
  },
  COMMON_LOGOUT: {
    path: '/logout',
    type: ROUTE_TYPE.COMMON
  },
  // データセット
  DATASETS_LIST: {
    id: 'SCR-DCV-1010',
    name: 'データセット一覧',
    path: '/rde/datasets',
    type: ROUTE_TYPE.DATASETS
  },
  DATASETS_DETAIL: {
    id: 'SCR-DCV-1020',
    name: 'データセット詳細',
    path: '/rde/datasets/:id',
    type: ROUTE_TYPE.DATASETS
  },
  DATASETS_EDIT: {
    id: 'SCR-DCV-1040',
    name: 'データセット基本情報編集',
    path: '/rde/datasets/:id/edit',
    type: ROUTE_TYPE.DATASETS
  },
  DATASETS_CATALOG_EDIT: {
    id: 'SCR-DCV-1041',
    name: 'データカタログ編集',
    path: '/rde/datasets/:id/catalogEdit',
    type: ROUTE_TYPE.DATASETS
  },
  // 全文検索
  METADATA_SEARCH: {
    id: 'SCR-DCV-1100',
    name: '全文検索',
    path: '/rde/datasets/metadata',
    type: ROUTE_TYPE.DATASETS
  },
  DATASET_RESTRUCTURE_SETTING: {
    id: 'SCR-DCV-1110',
    name: '再構造化テンプレート選択',
    path: '/rde/datasets/:id/datasetRestructureSetting',
    type: ROUTE_TYPE.DATASETS
  },
  COPY_RESTRUCTURE_SETTING: {
    id: 'SCR-DCV-1130',
    name: 'コピー再構造化設定',
    path: '/rde/datasets/:id/copyRestructureSetting',
    type: ROUTE_TYPE.DATASETS
  },
  DATA_LIST: {
    id: 'SCR-DCV-1200',
    name: 'データ一覧(ギャラリー表示)',
    path: '/rde/datasets/:id/data',
    type: ROUTE_TYPE.DATASETS
  },
  DATA_DETAIL: {
    id: 'SCR-DCV-1210',
    name: 'データ詳細',
    path: '/rde/datasets/data/:id',
    type: ROUTE_TYPE.DATASETS
  },
  DATA_EDIT: {
    id: 'SCR-DCV-1230',
    name: '送り状編集',
    path: '/rde/datasets/data/:id/edit',
    type: ROUTE_TYPE.DATASETS
  },
  DATA_TEMPLATES_LIST: {
    id: 'SCR-DCV-2010',
    name: 'データセットテンプレート一覧',
    path: '/rde/datasets/templates',
    type: ROUTE_TYPE.DATASETS
  },
  DATA_TEMPLATES_OPEN: {
    id: 'SCR-DCV-2020',
    name: 'データセット開設',
    path: '/rde/datasets/templates/:id',
    type: ROUTE_TYPE.DATASETS
  },
  DATA_TEMPLATES_OPEN_CONFIRM: {
    id: 'SCR-DCV-2050',
    name: 'データセット開設確認',
    path: '/rde/datasets/templates/:id/confirm',
    type: ROUTE_TYPE.DATASETS
  },
  GROUPS_NEW: {
    id: 'SCR-DCV-5020',
    name: 'グループ新規登録',
    path: '/rde/datasets/groups/new',
    type: ROUTE_TYPE.DATASETS
  },
  GROUPS_ROOT: {
    id: 'SCR-DCV-5030',
    name: 'グループ詳細(ROOT)',
    path: '/rde/datasets/groups',
    type: ROUTE_TYPE.DATASETS
  },
  GROUPS_DETAIL: {
    id: 'SCR-DCV-5030',
    name: 'グループ詳細',
    path: '/rde/datasets/groups/:id',
    type: ROUTE_TYPE.DATASETS
  },
  GROUPS_EDIT: {
    id: 'SCR-DCV-5040',
    name: 'グループ編集',
    path: '/rde/datasets/groups/:id/edit',
    type: ROUTE_TYPE.DATASETS
  },
  // データ受入
  ENTRIES_LIST: {
    id: 'SCR-DCV-4010',
    name: '仕掛データセット一覧',
    path: '/data-entry/datasets',
    type: ROUTE_TYPE.ENTRIES
  },
  ENTRIES_ENTRY: {
    id: 'SCR-DCV-4020',
    name: '送り状入力',
    path: '/data-entry/datasets/:id/entry',
    type: ROUTE_TYPE.ENTRIES
  },
  ENTRIES_ENTRY_CONFIRM: {
    id: 'SCR-DCV-4030',
    name: '送り状入力確認',
    path: '/data-entry/datasets/:id/entry/confirm',
    type: ROUTE_TYPE.ENTRIES
  },
  ENTRIES_DATASETS_LIST: {
    id: 'SCR-DCV-4100',
    name: 'データ登録状況一覧',
    path: '/data-entry/datasets/entries',
    type: ROUTE_TYPE.ENTRIES
  },
  ENTRIES_DATASETS_DETAIL: {
    id: 'SCR-DCV-4110',
    name: 'データ登録状況詳細',
    path: '/data-entry/datasets/entries/:id',
    type: ROUTE_TYPE.ENTRIES
  },
  // 試料
  SAMPLES_LIST: {
    id: 'SCR-SMP-1010',
    name: '試料一覧',
    path: '/samples/samples',
    type: ROUTE_TYPE.SAMPLES
  },
  SAMPLES_DETAIL: {
    id: 'SCR-SMP-1020',
    name: '試料詳細',
    path: '/samples/samples/:id',
    type: ROUTE_TYPE.SAMPLES
  },
  SAMPLES_EDIT: {
    id: 'SCR-SMP-1030',
    name: '試料編集',
    path: '/samples/samples/:id/edit',
    type: ROUTE_TYPE.SAMPLES
  },
  // 装置
  INSTRUMENTS_LIST: {
    id: 'SCR-INS-1010',
    name: '装置一覧',
    path: '/instruments/instruments',
    type: ROUTE_TYPE.INSTRUMENTS
  },
  INSTRUMENTS_DETAIL: {
    id: 'SCR-INS-1020',
    name: '装置詳細',
    path: '/instruments/instruments/:id',
    type: ROUTE_TYPE.INSTRUMENTS
  },
  INSTRUMENTS_NEW: {
    id: 'SCR-INS-1030',
    name: '装置登録',
    path: '/instruments/instruments/new',
    type: ROUTE_TYPE.INSTRUMENTS
  },
  INSTRUMENTS_EDIT: {
    id: 'SCR-INS-1040',
    name: '装置編集',
    path: '/instruments/instruments/:id/edit',
    type: ROUTE_TYPE.INSTRUMENTS
  },
  // ユーザ
  USERS_PROFILE: {
    id: 'SCR-USR-1010',
    name: 'ユーザ公開プロフィール',
    path: '/rde-user-profile/users/:id',
    type: ROUTE_TYPE.USERS
  }
};
